export class ComponentsController {

    constructor(XRayUIStorage, $rootScope, $filter, $scope, $state, $stateParams, xrayLicensesDao, ComponentsDao,
            JFrogGridFactory, JFrogNotifications, uiGridConstants, $timeout, JFrogModal, $location, XRayUIState, XRayUtils) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.XRayUIStorage = XRayUIStorage;
        this.$location = $location;
        this.XrayUtils = XRayUtils;
        this.$stateParams = $stateParams;
        this.componentsDao = ComponentsDao;
        this.modal = JFrogModal;
        this.XRayUIState = XRayUIState;
        this.jfrogGridFactory = JFrogGridFactory;
        this.JFrogNotifications = JFrogNotifications;
        this.$filter = $filter;
        this.uiGridConstants = uiGridConstants;
        this.xrayLicensesDao = xrayLicensesDao;
        this.$timeout = $timeout;
        this.init();
        this.AdvancedSeacrchOpened = false;

        //this.selectedTimeSpan = {text: 'All', value: 'all'};
        this.packagesTypes.sort();

        if (this.$stateParams.query) {
            this.query = atob(this.$stateParams.query);
            this.XRayUIStorage.setItem('filters', {'Key': this.query});
            //this.getResults();
        }

        if (this.$stateParams.preset !== '' && this.$location.search().type !== 'sso') {
            this.XRayUIStorage.removeItem('filters');
            this.XRayUIStorage.setItem('filters', {pkg_type: this.$stateParams.preset});
        }

        if (_.isEmpty(this.$location.search()) && !this.XRayUIStorage.getItem(
                'filters') && this.$location.search().type !== 'sso') {

            if (this.$stateParams.query) {
                this.query = atob(this.$stateParams.query);
                this.XRayUIStorage.setItem('filters', {'Key': this.query});
                //this.getResults();
            }
            else {
                //this.getResults('*');
            }
        }


        this.checkValidQ();
        //this.getLicensesNames();

        this.dateRangeStart = moment().add(-1, 'd');
        this.dateRangeEnd = moment();

        this.optionsFrom = {format: 'DD.MM.YYYY', keepOpen: false, showTodayButton: false, allowInputToggle: true};
        this.optionsTo = {format: 'DD.MM.YYYY', keepOpen: false, showTodayButton: false, allowInputToggle: true};

        this.update(this.dateRangeStart, this.dateRangeEnd);

        this.XRayUIState.removeState('lastTabClicked');


        this.$timeout(() => {
            if (!_.isEmpty(this.$location.search()) || this.XRayUIStorage.getItem(
                    'filters') && this.$location.search().type !== 'sso') {
                this.setFiltersFromUrlParams();
            }
            console.log("boom");

        }, 500)

        if (this.$location.search().type == 'sso') {
            console.log("FULL URL IS:", this.$location.url());
            let url = this.$location.url().split('?')[0];
            console.log("URL IS", url);
            this.$timeout(() => {
                this.$location.url(url);
            }, 1000)

        }


    }

    init() {
        this._createGrid();
        this.showGrid = true;
        this.date = '';
        this.openDateBoard = [];
        this.filters = {};
        this.defaultPagination = {direction: 'desc', num_of_rows: 20, order_by: 'last_updated', page_num: 1};
        this.filters.pkg_type = 'All Package Types';
        this.filters.component_type = 'All';
        this.filters.all_components = false;
        //this.filters.min_severity = "Minor";
        this.componentTypes = ['All', 'Packages', 'Files', 'Builds'];
        this.severityType = ['All', 'Unknown', 'Information', 'Low', 'Medium', 'High'];
        this.packagesTypes = this.getPackagesType();
        this.timeSpanOptions = [
            {text: 'All', value: 'all'},
            {text: 'Last 3 Hours', value: '3h'},
            {text: 'Last 24 hours', value: '24h'},
            {text: 'Last 3 Days', value: '3d'},
            {text: 'Last 7 Days', value: '7d'},
            {text: 'Custom Range', value: 'CUSTOM'}
        ];
    }

    _createGrid() {
        this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
                .setRowsPerPage(20)
                .setColumns(this._getColumns())
                .setExternalPagination((pagination) => this.filterType(pagination))
                .setGridData([]);
        /*
         .setButtons(this._getActions())
         */

        this.gridOptions.setGridData([]);

    }


    search() {
        this.$state.go('components', {query: btoa(this.query), pkg_type: btoa(this.typeFilter)});
    }

    onChange(type) {
        if (type === 'licenseType') {

            let selectedLicenses = _.filter(this.licensesItems, function (item) {
                return item.isSelected;
            });

            this.filters.licenses = _.map(selectedLicenses, 'text');
        }
    }


    filterType(pagination) {
        if (this.$location.search().type == 'sso') {
            this.$state.reload();
            return;
        }

        let _this = this;
        pagination = pagination || this.defaultPagination;
        let payload = this.buildPayload();
        let promise = '';
        promise = this.componentsDao.paginSearch(pagination, payload).$promise;

        promise.then((results) => {
            if (results.data) {
                if (results.data.length == 0) {
                    this.showGrid = false;
                } else {
                    this.showGrid = true;
                }

                if (results.data.length) {
                    this.resultsSummaryString = `Showing ${results.total_count} out of ${results.total_indexed} Components`;
                } else {
                    this.resultsSummaryString = `  No Results found`;
                }
            }
            this.AdvancedSeacrchOpened = false;
        });

        if (!payload.Key || payload.Key == '*') {
            delete payload.Key;
        }
        this.$location.search(payload);
        this.XRayUIStorage.setItem('filters', payload);

        return promise;

    }

    buildPayload() {
        let payload = {};
        let selectedpackages = _.filter(this.packagesTypes, (item) => {
            return item.isSelected;
        });
        if (selectedpackages.length > 0) {
            this.filters.pkgTypes = _.map(selectedpackages, (f) => {
                if (f.value) {
                    return f.value;
                }
                return f.text;
            });
        } else {
            delete this.filters.pkgTypes;
        }

        payload.Key = '*';
        payload.cve = this.cveConvertor();
        let filterPkg = '';
        let filterComponentType = '';
        if (this.filters.component_type.toLowerCase() !== 'all') {
            filterComponentType = this.filters.component_type.toLowerCase().split(' ')[0];
        }
        if (filterComponentType.toLowerCase() === 'artifacts') {
            filterComponentType = 'root';
        }
        if (this.filters.component_type.toLowerCase() === 'builds') {
            filterPkg = 'build';
            filterComponentType = '';
        }
        if (this.filters.pkgTypes) {
            payload.pkg_type = this.filters.pkgTypes.map(pkg => pkg.toLowerCase());
        }
        if (this.filters.component_type.toLowerCase() === 'builds') {
            payload.pkg_type = ['builds'];
        } else if (this.filters.component_type.toLowerCase() === 'files') {
            payload.pkg_type = ['generic'];
            filterComponentType = '';
        }

        if (this.filters.min_severity == 'All') {
            delete this.filters.min_severity;
        }

        payload.severity = this.filters.min_severity;
        payload.component_type = filterComponentType;
        payload.licenses = this.filters.licenses;
        if (this.filters.last_update_date) {
            payload.last_update_date = this.filters.last_update_date.toString();
        }

        if (this.selectedTimeSpan) {

            if (this.selectedTimeSpan.value === 'CUSTOM') {
                if (this.filters.dateRange) {
                    payload.date = this.filters.dateRange;
                }
            } else if (this.selectedTimeSpan.value !== 'all') {
                payload.date = this.selectedTimeSpan.value;
            }
        }
        payload = _.omit(payload, _.isEmpty);
        if (this.query == '') {
            payload.Key = '*';
        } else {
            payload.Key = this.query;
        }
        payload.all_components = this.filters.all_components

        return payload;
    }

    refreshGrid() {
        this.searchBtnTriggered = true;
        this.$timeout(() => {
            this.gridOptions.resetPagination();
        })

    }

    getResults(query) {
        this.componentsDao.search({
            Key: query || this.query
        }).$promise.then((results) => {
            this.results = results.results;
            this.gridOptions.setGridData(results.results);
            if (results.results) {
                this.resultsSummaryString = `Showing ${results.results.length} out of ${results.sum} Components`;
            }
            if (!results.length) {
                //                this.JFrogNotifications.create({warn: `Search for '${this.query}' returned no
                // results`})
            }
        });
    }


    onChangeTimeSpan(time) {


        if (time.value.toLowerCase() === 'custom') {

            let modalInstance;
            let modalScope = this.modalScope = this.$scope.$new();
            modalScope.$rootScope = this.$rootScope;
            modalScope.endDateBeforeRender = this.endDateBeforeRender;
            modalScope.endDateOnSetTime = this.endDateOnSetTime;
            modalScope.startDateBeforeRender = this.startDateBeforeRender;
            modalScope.startDateOnSetTime = this.startDateOnSetTime;

            modalInstance = this.modal.launchModal('select_date_range_modal', modalScope);
        } else {
            this.filters.dateRange = time.value;
        }
    }


    apply() {

        let start = this.dateRangeStart;
        let end = this.dateRangeEnd;

        if (end && start) {
            //this.filters.dateRange = [end, start];
            this.filters.dateRange = `${start}-${end}`;


        }

    }

    getIcon(pkgType) {
        if (pkgType === 'maven') {
            return 'pom';
        }
        if (pkgType === 'generic') {
            return 'general';
        }
        return pkgType;
    }

    _getColumns() {
        return [
            {
                name: 'Type',
                displayName: 'Type',
                cellTemplate: `<div  jf-tooltip="{{row.entity.pkg_type}}" ng-class="'icon-' + grid.appScope.Components.getIcon(row.entity.pkg_type)" class="ui-grid-cell-contents pkg-type-cell" ></div>`,
                field: 'pkg_type',
                width: '5%'
            },
            {
                name: 'Name',
                displayName: 'Name',
                field: 'pkg_name',
                cellTemplate: `<div class="ui-grid-cell-contents"><a class="jf-link"  ui-sref="components.details({componentID: row.entity.pkg_id})">{{row.entity.pkg_name}}</a></div>`,
                width: '50%'
            },
            {
                name: 'Latest Version',
                displayName: 'Latest Version',
                cellTemplate: `<div ng-if="row.entity.latest_version && row.entity.latest_version !== ''" class="ui-grid-cell-contents"> {{row.entity.latest_version}}</div><div ng-if="row.entity.latest_version.trim() === ''" class="ui-grid-cell-contents"> N/A</div>`,
                field: 'latest_version',
                width: '15%'
            },
            {
                name: 'Last Updated',
                displayName: 'Modified',
                cellTemplate: `<div class="ui-grid-cell-contents" ui-sref="components.details({componentID: row.entity.pkg_id})">{{row.entity.last_updated | date:'medium'}}</div>`,
                field: 'last_updated',
                sort: {
                    direction: this.uiGridConstants.DESC
                },
                width: '15%'
            },
            {
                name: 'Severity',
                displayName: 'Status',
                cellTemplate: `<div class="ui-grid-cell-contents severity"  ng-class="grid.appScope.Components.convertSeverity(row.entity.top_severity)"> {{row.entity.top_severity}}</div>`,
                field: 'top_severity',
                width: '15%'
            }

        ];
    }

    convertSeverity(severity) {
        return this.XrayUtils.convertSeverityStatus(severity)
    }

    checkValidQ() {

        this.$timeout(() => {
            if (this.query === 'undefined' || typeof this.query == 'undefined') {
                this.query = '';
            }

        });

    }

    cveConvertor() {
        if (!this.filters.cveQuery) {
            return null;
        }
        let hasCve = this.filters.cveQuery.toLowerCase().indexOf('cve-') > -1;
        let original = _.cloneDeep(this.filters.cveQuery).toUpperCase().replace('CVE-', '');
        let final = '';


        switch (true) {
            case /^\d{4}-\d$/.test(original.toUpperCase()):
                final = 'CVE-' + original + '.*';
                //console.log('THIS IS A full VALID FORMAT', final);
                break;

            case /^\d{4}-\d{0,3}$/.test(original.toUpperCase()):
                final = 'CVE-' + original + '.*';
                //console.log('THIS IS A partial second arg VALID FORMAT', final);
                break;
            case /^\d/.test(original.toUpperCase()):
                if (!hasCve) {
                    final = '.*' + original + '.*';
                } else {
                    final = 'CVE-' + original + '.*';
                }

                //console.log('THIS IS A partial first arg VALID FORMAT', final);
                break;
            default:
                //console.log('didnt find any');
                final = undefined;
                break;

        }
        if (final) {
            final = final.replace('--', '-');
            final = final.replace('-CVE', '');
            final = final.replace('.*CVE', 'CVE');
        }

        //console.log('final query', final);
        return final;
    }

    checkCveValidity(val) {
        if (!val) {
            return true;
        }

        let nomalizedVal = val.toLowerCase().replace('cve-', '')


        if (val == 'true' || val == "") {
            return true
        }
        return /^\d{4}-\d$/.test(nomalizedVal.toUpperCase()) || /^\d{4}-\d{0,3}$/.test(
                nomalizedVal.toUpperCase()) || /^\d/.test(nomalizedVal.toUpperCase());
    }

    filterChanged(origin) {

        this.filters.component_type == 'Builds' ? this.filters.pkg_type = 'All Package Types' : '';
    }

    clearFilters(filterToRemove = 'all') {
        console.log("Need to Remove", filterToRemove)
        this.cleanPackagesTypes(filterToRemove);

        if (filterToRemove === 'all') {
            this.searchBtnTriggered = false;
        }

        //this.refreshGrid();
    }

    cleanPackagesTypes(filterToRemove) {

        if (filterToRemove == 'all') {
            this._cleanPakagedTypes();

            this.filters.pkg_type = 'All Package Types';
            delete this.filters;
            delete this.selectedTimeSpan;
            this.filters = {};
            this.filters.cveQuery = '';
            this.query = '';
            this.filters.component_type = 'All';
            this.XRayUIStorage.removeItem('filters');
        } else {

            if (filterToRemove == "component_type") {
                this.filters[filterToRemove] = "All";
            }
            else if (filterToRemove == 'pkgTypes') {
                this._cleanPakagedTypes();
                delete this.filters.pkgTypes
            } else if (filterToRemove == 'all_components') {
                this.filters.all_components = false;

            }
            else if (filterToRemove == 'dateRange') {
                delete this.selectedTimeSpan;
                delete this.filters[filterToRemove]
            }
            else {
                delete this.filters[filterToRemove]
            }
            this.refreshGrid()
        }
    }

    _cleanPakagedTypes() {
        _.forEach(this.packagesTypes, (n, key) => {
            if (n) {
                n.isSelected = false;
            }
        });
    }

    getNormalizedFilterName(filter) {

        if (filter == 'date_range') {
            return 'By Date'
        }
        if (filter == 'pkgTypes') {
            return 'Package Types'
        }
        if (filter === 'cveQuery') {
            return 'CVE'
        }
        if (filter === 'all_components') {
            return 'Advanced Search'
        }


        return _.startCase(filter)
    }

    getNormalizedFilterVal(filterName, filterVal) {

        if (filterName === 'pkgTypes') {
            return filterVal.map((pkg, i) => {
                if (filterVal.length === i + 1) {
                    return _.startCase(pkg)
                } else {
                    return _.startCase(pkg) + ', '
                }
            }).join('')
        } else if (filterName === 'dateRange') {

            if (this.selectedTimeSpan.text.toLowerCase() === 'custom range') {
                let start = this.$filter('date')(filterVal.toLowerCase().split('-')[0], 'dd-MMM-yyyy');
                let end = this.$filter('date')(filterVal.toLowerCase().split('-')[1], 'dd-MMM-yyyy');
                return `Custom Range (${start} - ${end})`
            }
            return this.selectedTimeSpan.text
        } else if (filterName === 'all_components') {

            return "Include all Components"
        }

        return filterVal
    }


    setFiltersFromUrlParams() {
        let filterParams;

        if (!_.isEmpty(this.XRayUIStorage.getItem('filters'))) {
            this.$location.search(this.XRayUIStorage.getItem('filters'));
        }

        if (_.isEmpty(this.$location.search())) {
            filterParams = this.XRayUIStorage.getItem('filters');
        }
        else {
            filterParams = this.$location.search();
        }


        if (filterParams.pkg_type && filterParams.pkg_type !== 'builds') {
            if (_.isArray(filterParams.pkg_type)) {
                if (filterParams.pkg_type[0] !== 'builds' && filterParams.pkg_type[0] !== 'generic') {
                    _.forEach(filterParams.pkg_type, (val, key) => {

                        if (this.packagesTypes[_.findIndex(this.packagesTypes,
                                {'value': val.toLowerCase()})]) {
                            this.packagesTypes[_.findIndex(this.packagesTypes,
                                    {'value': val.toLowerCase()})].isSelected = true;
                        }

                    });
                    let selectedpackages = _.filter(this.packagesTypes, (item) => {
                        return item.isSelected;
                    });
                    this.filters.pkgTypes = _.map(selectedpackages, (f) => {
                        if (f.value) {
                            return f.value;
                        }
                        return f.text;
                    });
                }

            }
            else {

                if (this.packagesTypes[_.findIndex(this.packagesTypes,
                        {'value': filterParams.pkg_type.toLowerCase()})]) {

                    this.packagesTypes[_.findIndex(this.packagesTypes,
                            {'value': filterParams.pkg_type.toLowerCase()})].isSelected = true;
                }

            }

        }

        _.forEach(filterParams, (val, key) => {

            switch (key) {

                case 'Key':
                    if (val.trim() !== '*') {
                        this.query = val;
                    }
                    break;

                case 'component_type':
                    this.filters.component_type = _.capitalize(val);
                    break;

                case 'severity':
                    this.filters.min_severity = val;
                    break;
                case 'pkg_type':

                    if (val == 'builds') {
                        this.filters.component_type = 'Builds';
                    }

                    if (val == 'generic') {
                        this.filters.component_type = 'Files';
                    }
                    break;

                case 'date':
                    console.log('**** DATE IT PARAMS')

                    this.filters.dateRange = val
                    if (val.toLowerCase().indexOf('-') == -1) {
                        this.selectedTimeSpan = this.timeSpanOptions[_.findIndex(this.timeSpanOptions, {'value': val})];


                    } else {

                        this.selectedTimeSpan = this.timeSpanOptions[_.findIndex(this.timeSpanOptions,
                                {'value': 'CUSTOM'})];


                        let start = val.toLowerCase().split('-')[0];
                        let end = val.toLowerCase().split('-')[1];
                        this.startdateRangeEndShow = this.$filter('date')(start, 'dd-MMM-yyyy');
                        this.enddateRangeEndShow = this.$filter('date')(end, 'dd-MMM-yyyy');
                        if (end && start) {
                            //this.filters.dateRange = [end, start];
                            this.filters.dateRange = `${start}-${end}`;
                        }


                    }


                    break;
            }
        });
    }

    clearQuery(type = 'comp') {
        if (type == 'comp') {
            this.query = '';
        } else {
            this.filters.cveQuery = '';
        }
    }

    getPackagesType() {


        let p = [
            {
                text: 'Maven',
                iconClass: 'icon icon-pom',
                isSelected: false,
                value: 'maven'
            },
            {
                text: 'Docker',
                iconClass: 'icon icon-docker',
                isSelected: false,
                value: 'docker'
            },
            {
                text: 'NuGet',
                iconClass: 'icon icon-nuget',
                isSelected: false,
                value: 'nuget'
            },
            {
                text: 'Npm',
                iconClass: 'icon icon-npm ',
                isSelected: false,
                value: 'npm'
            },
            {
                text: 'Bower',
                iconClass: 'icon icon-bower',
                isSelected: false,
                value: 'bower'
            },
            {
                text: 'Pypi',
                iconClass: 'icon icon-pypi',
                isSelected: false,
                value: 'pypi'
            },
            {
                text: 'Debian',
                iconClass: 'icon icon-deb',
                isSelected: false,
                value: 'debian'
            },
            {
                text: 'RPM',
                iconClass: 'icon icon-rpm',
                isSelected: false,
                value: 'rpm'
            },
            {
                text: 'Gems',
                iconClass: 'icon icon-rubygems',
                isSelected: false,
                value: 'rubygems'
            }, {
                text: 'Alpine',
                iconClass: 'icon icon-alpine',
                isSelected: false,
                value: 'alpine'
            }
        ];
        return p;
    }


    update(dateRangeStart, dateRangeEnd) {
        this.showEndDatePicker = true;

        this.optionsFrom.maxDate = dateRangeEnd;
        this.optionsTo.minDate = dateRangeStart;
        this.optionsTo.maxDate = new Date();
        this.dateRangeEnd = dateRangeEnd._d;
        this.dateRangeStart = dateRangeStart._d;
        this.startDateToShow = this.$filter('date')(dateRangeStart.format(), 'dd-MMM-yyyy');
        this.endDateToShow = this.$filter('date')(dateRangeEnd.format(), 'dd-MMM-yyyy');

    }

    onFocus(type) {
        if (this.openDateBoard.indexOf(type) < 0) {
            this.openDateBoard.push(type);
        }
    }

    onBlur(type) {
        if (this.openDateBoard.indexOf(type) > -1) {
            this.openDateBoard.splice(this.openDateBoard.indexOf(type), 1);
        }
    }
}




// WEBPACK FOOTER //
// ./modules/xray/states/components/components.controller.js